import React, { useEffect, useState } from 'react';
import ThemeProvider from './theme';
import { Provider, useDispatch, useSelector } from "react-redux";
import Router from './routes';
import store from './redux/store';
import { SnackbarProvider } from "notistack";
import CustomSnackbar from './components/messageBox/customSnackbar';
import ScrollToTop from './components/scrollToTop';
import { server } from './utils/server';
import { authHeader } from './helpers/authHeader';
import CacheBuster from './CacheBuster';
import VesrionUpdate from './components/modals/versionUpdate';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactGA from 'react-ga';
import initializeAnalytics from '../src/analytics';
import NoInternet from './components/modals/noInternet';
import CookieStorage from './utils/cookieStorage';
import jwt_decode from 'jwt-decode';
import authServices from './services/authServices';
// import { saveUser } from './redux/reducers/userSlice';
import { checkLogin, loggout } from './utils/functions';
import TermsGate from './components/TermsGate';
import { saveUser, updateWatchlist } from './redux/reducers/userSlice';
// import { checkLogin } from './utils/functions';
import userServices from './services/userServices';
import { useLocation } from 'react-router-dom';
// import TermsGate from './components/TermsGate';

initializeAnalytics();

const interCeptor = () => {

  server.interceptors.request.use((config) => {
    const token = authHeader();
    config.headers.Authorization = token;
    return config;
  }, null, { synchronous: true });
}
function App() {
  const [networkOffLine, setNetworkOffline] = useState(false);
  const location = useLocation();

  function checkInternetConnection() {
    if (!navigator.onLine) {
      setNetworkOffline(true);
    }
  }
  useEffect(() => {
    checkInternetConnection();
    const onlineHandler = () => {
      setNetworkOffline(false);
      console.log('You are online!');
    };
    const offlineHandler = () => {
      checkInternetConnection();
    };
    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);
    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

 
  interCeptor()
  useEffect(() => {
    
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  return (
    <ThemeProvider>
      <GoogleOAuthProvider clientId="319102982878-s71f4e19hp1s0un042ibg5t098k4n87l.apps.googleusercontent.com">
        <CacheBuster>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
              return (
                <VesrionUpdate open={true} />
              )
            }
            return (
              <Provider store={store}>
                <SnackbarProvider
                  anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom"
                  }}
                  autoHideDuration={5000}
                  Components={{
                    success1: CustomSnackbar
                  }} >
                  <ScrollToTop />
                  <UserBootstrap />
                  {location.pathname !== '/' && <TermsGate />}
                  <Router />
                  {/* <WhatsappWidget/> */}
                </SnackbarProvider>
              </Provider>
            )
          }}
        </CacheBuster>
        {networkOffLine && (
          <NoInternet open={networkOffLine}/>
          // <ModalComponent
          //   open={networkOffLine}
          //   children={<Notification message="This property is temporarily unavailable." redirectPath="/dashboard" />}
          // />
        )}
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

export default App;

function UserBootstrap() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user?.data);

  useEffect(() => {
    const loadUser = async () => {
      try {
        if (checkLogin() && (!user || !user._id)) {
          const token = CookieStorage.get('access');
          if (token) {
            const decodedToken = jwt_decode(token);
            if (decodedToken?.id) {
              const res = await authServices.getUser(decodedToken?.id);
              if (res && res.success && res.data) {
                    const userWithUrl = { 
                  ...res.data[0], 
                  url: res.url 
                };
                dispatch(saveUser(userWithUrl))
                
              }
              const Watchlist = await userServices.getMyWatchlist();
              if(Watchlist && Watchlist.success && Watchlist.data){
                dispatch(updateWatchlist(Watchlist.data));
              }
            }
          
          }
        }
      } catch (error) {
        console.error('Error loading user data:', error);
      }
    };

    loadUser();
  }, [dispatch, user]);

  return null;
}
